/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BuildingConstructionType {
    Massivbau = 'Massivbau',
    Holzbau = 'Holzbau'
  }

    export const BuildingConstructionTypeTranslocoMap: Record<BuildingConstructionType, string> = {
    [BuildingConstructionType.Massivbau]: 'buildingConstructionType.massivbau',
    [BuildingConstructionType.Holzbau]: 'buildingConstructionType.holzbau',
    };

    export const BuildingConstructionTypeOptions = [
  { value: BuildingConstructionType.Massivbau, labelKey: 'buildingConstructionType.massivbau' },
  { value: BuildingConstructionType.Holzbau, labelKey: 'buildingConstructionType.holzbau' },
    ];

